import Component from '@glimmer/component';
import HeroSectionV2 from 'madow-tech/components/sections/hero-section-v2';
import ServicesGrid from 'madow-tech/components/sections/services-grid';
import ProcessTimeline from 'madow-tech/components/sections/process-timeline';
import SuccessCases from 'madow-tech/components/sections/success-cases';
import TechnologiesGrid from 'madow-tech/components/sections/technologies-grid';
import RatesBanner from 'madow-tech/components/sections/rates-banner';
import Testimonials from 'madow-tech/components/sections/testimonials';
import TeamExplorer from 'madow-tech/components/sections/team-explorer';
import ContactCta from 'madow-tech/components/sections/contact-cta';
import ScheduleCta from 'madow-tech/components/sections/schedule-cta';

export default class HomePage extends Component {
  <template>
    <main
      id="main-content"
      role="main"
      aria-label="Main content"
      class="relative z-10 px-2 sm:px-4 md:px-8 lg:px-16"
    >
      <HeroSectionV2 />
      <ServicesGrid />
      <ProcessTimeline />
      <SuccessCases />
      <RatesBanner />
      <TechnologiesGrid />
      <ScheduleCta />
      <Testimonials />
      <TeamExplorer />
      <ContactCta />
    </main>
  </template>
}
